<template>
    <div class="terms-page">
        <div class="menu-item">
            <a v-bind:href="`/${app_locale}/term-online-sale`">
                {{ $t('header.link_term_purchase') }}
            </a>
        </div>
        <div class="menu-item">
            <a v-bind:href="`/${app_locale}/term-reservation`">
                {{ $t('header.link_term_reservation') }}
            </a>
        </div>
        <!-- <div class="menu-item">
            <a v-bind:href="`/${app_locale}/term-auto-pass`">
                {{ $t('header.link_term_auto_pass') }}
            </a>
        </div> -->
        <div class="menu-item">
            <a v-bind:href="`/${app_locale}/term-free-ferry`">
                {{ $t('header.link_term_free_ferry') }}
            </a>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';


export default {
    components: {
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
        ])
    }
}
</script>
